import { Response, apiAbortController } from '@ui/src';
import api from '../../../../api/api';
import { Device, DeviceSession, EmployeeProfile, Role } from '../types';

export const profileApi = api.injectEndpoints({
  endpoints: (build) => ({
    getEmployeeProfile: build.query<{ data: EmployeeProfile }, void>({
      query: () => ({
        url: '/v1/employees/whoami',
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getEmpoyeeRoles: build.query<Response<Role>, void>({
      query: () => ({
        url: '/v1/employees-roles-templates',
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getEmployeeDevices: build.query<Response<Device>, string>({
      query: (cursor) => ({
        url: `/v1/devices?take=20${cursor ? `&cursor=${cursor}` : ''}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getPspPartnerAccounts: build.query<Response<any>, void>({
      query: () => ({
        url: '/v1/psp-accounts?all=true',
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    endSession: build.mutation<{ data: Device }, string>({
      query: (id) => ({
        url: `/v1/devices/${id}`,
        method: 'DELETE',
      }),
    }),
    logout: build.mutation<any, void>({
      query: (body) => ({
        url: '/v1/auth/logout',
        method: 'POST',
        body,
      }),
    }),
    getProfileDeviceSessions: build.query<
      Response<DeviceSession>,
      { id: string; entityId: string; query: string }
    >({
      query: (data) => ({
        url: `/v1/devices/${data.id}/user/${data.entityId}/sessions${data.query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const {
  useGetEmployeeProfileQuery,
  useLazyGetEmployeeProfileQuery,
  useLazyGetEmpoyeeRolesQuery,
  useLogoutMutation,
  useLazyGetEmployeeDevicesQuery,
  useEndSessionMutation,
  useLazyGetPspPartnerAccountsQuery,
  useLazyGetProfileDeviceSessionsQuery,
} = profileApi;

export const {
  endpoints: {
    getEmployeeProfile,
    getEmpoyeeRoles,
    logout,
    getEmployeeDevices,
    endSession,
    getPspPartnerAccounts,
    getProfileDeviceSessions,
  },
} = profileApi;
